import { type Location } from '@koala/sdk';
import { POS_UNAVAILABLE_COPY } from './constants';
import * as Styled from './styles';
import { CloudOff } from '@/components/uielements/icon/cloud-off';

interface Props {
  location?: Location;
  className?: string;
}

/**
 * Presentational "restaurant can't accept online orders" banner shown on the menu page and
 * repeated at checkout (TEAM-14640). Announced via `role="status"` so assistive tech is
 * notified when the state appears. Adds a "Call the restaurant" affordance when a phone
 * number is available (AC1: "call the restaurant or come back later").
 */
export const PosUnavailableBanner = ({ location, className }: Props) => {
  const phoneNumber = location?.phone_number;

  return (
    <Styled.Banner role="status" className={className}>
      <Styled.BannerContent>
        <CloudOff title="" width="20" height="20" aria-hidden focusable={false} />
        <span>
          {POS_UNAVAILABLE_COPY.bannerMessage}
          {phoneNumber ? (
            <>
              {' '}
              <Styled.CallLink href={`tel:${phoneNumber}`}>
                {POS_UNAVAILABLE_COPY.callCta}
              </Styled.CallLink>
            </>
          ) : null}
        </span>
      </Styled.BannerContent>
    </Styled.Banner>
  );
};
